import React, {useContext, useEffect} from "react";
import {
  BrowserRouter as Router,
} from "react-router-dom";
import './App.css';
import Routes from './config/Routes';
import CreateFolderModal from "./components/modals/CreateFolderModal";
import {GlobalContext} from "./context/GlobalState";
import MoveModal from "./components/modals/MoveModal";
import ReactGA from 'react-ga';
import Plaudy from "plaudy";

const App = () => {
  useEffect(() => {
    ReactGA.initialize('UA-114958254-1');
    Plaudy.init('WRedxmMSzXfcs1c');
    Plaudy.identify('Web App');
  }, []);

  const {createFolderModalIsOpen, closeCreateFolderModal, moveModalIsOpen, closeMoveModal, moveEntityType, moveEntity} = useContext(GlobalContext);

  return (
    <Router>
      <Routes/>
      <CreateFolderModal
        isOpen={createFolderModalIsOpen}
        closeModal={closeCreateFolderModal}
      />
      <MoveModal
        isOpen={moveModalIsOpen}
        closeModal={closeMoveModal}
        entityType={moveEntityType}
        entity={moveEntity}
      />
    </Router>
  );
};

export default App;
